import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "../../PagesStyles/AdminPurchaseEntryNew.module.css";
import AdminHeading from "../Heading/AdminHeading";
import AlertMessage from "Components/Other Functions/AlertMessage";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import { useNavigate, useParams } from "react-router-dom";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import {
  PurchaseEntryFields,
  PurchaseEntryLooseDiamondNewFields,
  PurchaseEntryLooseStoneNewFields,
  PurchaseEntryNewFields,
} from "Components/support/Allfields/purchasefields";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { RiAddBoxFill } from "react-icons/ri";
import { IoMdRefresh } from "react-icons/io";
import { GoTrash } from "react-icons/go";
import { Icon } from "@iconify/react";
import Summary from "Components/AdminPurchaseEntryNew/Summary";
import SkuForm from "Components/AdminPurchaseEntryNew/SkuForm";
import { useMutation, useQuery } from "@tanstack/react-query";
import GetApiService from "Components/Api/getapiService";
import {
  DiamondFields,
  getAllPaymentMethod,
  getPurchaseEntryFormData,
  HeadersForAllCategory,
  HeadersForStones,
  looseDiamondId,
  looseStoneId,
  purchaseEntryEditJSon,
  purchaseEntryJson,
  selectStyle,
  StoneFields,
} from "utils/helpers";
import toast from "react-hot-toast";
import PaymentModeForm from "Components/AdminPurchaseEntryNew/PaymentModeForm";
import Select from "react-select";
import { a154, a155, a156, a166, a167, a194 } from "Components/Api/RootApiPath";
import StoneSummary from "Components/AdminPurchaseEntryNew/StoneSummary";
import DiamondSummary from "Components/AdminPurchaseEntryNew/DiamondSummary";
import PaymentsEntryTable from "Components/AdminPurchaseEntryNew/PaymentsEntryTable";
import AmountSection from "Components/AdminPurchaseEntryNew/AmountSection";
import { sendFormData } from "services/purchaseServices";
import { MdCheck } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { Check, Refresh } from "@mui/icons-material";
import Spinner from "Components/CommonComponents/Spinner";
import AdminBreadCrump from "../Heading/AdminBreadCrump";

const AdminPurchaseEntryNew = ({ editStatus, defaultValues }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [errorMessage, setErrorMessage] = useState(null);
  const [active, setActive] = useState("AddNew");
  // const [renderSummary,setIsRenderSummary] = useState(false)
  const [messageToShow, setMessageToShow] = useState("");
  const [messageType, setMessageType] = useState("");
  const [showError, setShowError] = useState(false);
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [category, setCategory] = useState("");
  const [purchaseCreateLoading, setPurchaseCreateLoading] = useState(false);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const CompanyId = adminLoggedIn.CompanyId;
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const EmployeeId = adminLoggedIn.EmployeeId;
  const labelFormat = parseInt(adminLoggedIn.Clients.LabelFormat);
  const apiService = new GetApiService(clientCode);
  console.log(adminLoggedIn)
  const fetchData = async () => {
    try {
      const data = await apiService.fetchAllCustomers();
      return data;
    } catch (e) {
      throw new Error("Failed to fetch vendors");
    }
  };

  const fetchRDPurchaseList = async () => {
    try {
      const data = await apiService.fetchAllRDPurchaseList();
      return data;
    } catch (e) {
      throw new Error("Failed to fetch RD purchase list");
    }
  };

  const {
    data: vendorlist,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["vendorlist"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
  });
  const {
    data: RDPurchaseList,
    isLoading: RDPurchaseListIsLoading,
    isError: RDPurchaseListIsError,
    refetch: RDPurchaseRefetch,
  } = useQuery({
    queryKey: ["getRDPurchaseList"],
    queryFn: fetchRDPurchaseList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
  });

  // const purchaseEntryCreateMutation = useMutation({
  //   mutationFn:({formdata,data})=>sendFormData({formData,data})
  // })

  const apifields = useMemo(
    () =>
      adminLoggedIn?.Modules?.filter(
        (module) => module?.PageName === "purchase_entry"
      ),
    [adminLoggedIn]
  );

  // Log the updated itemfields
  const localfields = useMemo(() => toPlainFields(PurchaseEntryNewFields), []);

  const looseStoneLocalFields = useMemo(
    () => toPlainFields(PurchaseEntryLooseStoneNewFields),
    []
  );
  const looseDiamonLocalFields = useMemo(
    () => toPlainFields(PurchaseEntryLooseDiamondNewFields),
    []
  );

  const apifieldsControls = useMemo(
    () => (apifields?.length && apifields[0]?.PageControls) || [],
    [apifields]
  );

  const [itemfields, setItemfields] = useState(() =>
    localfields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );
  const [itemLooseDiamondfields, setItemLooseDiamondfields] = useState(() =>
    looseDiamonLocalFields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );
  const [itemLooseStonefields, setItemLooseStonefields] = useState(() =>
    looseStoneLocalFields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );
  const [fields, setFields] = useState([]);

  const [editValues, setEditValues] = useState();
  const [edit, setEdit] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });
  const specificField = watch("StockKeepingUnit");
  const skus = watch("skus");
  const LotNumber = watch("LotNumber");
  const paymentTypes = watch("paymentTypes");
  const inputPaymentMode = watch("inputPaymentMode");
  const VendorName = watch("VendorName");
  const FineGold = watch("FineGold");
  const invoiceNumber = watch("invoiceNumber");
  const TotalFineMetal = watch("TotalFineMetal");
  const gstCheckbox = watch("gstCheckbox");
  const TotalBillAmount = watch("TotalBillAmount");
  const TotalTaxableAmount = watch("TotalTaxableAmount");
  const TotalRODiscount = watch("TotalRODiscount");
  const AdvanceAmount = watch("advanceamount");
  const TotalPaidAmount = watch("TotalPaidAmount");
  const invoiceDate = watch("invoiceDate");
  const status = watch("status");
  console.log(VendorName)

  useEffect(() => {
    if (!editStatus && RDPurchaseList?.length) {
      setValue(
        "LotNumber",
        +RDPurchaseList[RDPurchaseList?.length - 1]?.LotNumber + 1
      );
    }
  }, [RDPurchaseList, editStatus]);

  useEffect(() => {
    if (editStatus) {
      setIsSummaryOpen(true);
    }
  }, [editStatus]);

  useEffect(() => {
    const vendor = vendorlist?.find((vendr) => vendr?.Id == VendorName?.value);
    if (vendor?.Id) {
      setValue("TotalFineGold", vendor?.FineGold);
      setValue("TotalFineSilver", vendor?.FineSilver);
      setValue("advanceamount", vendor?.AdvanceAmt);
      setValue("balanceamount", vendor?.BalanceAmt);
    }
  }, [VendorName]);

  useEffect(() => {
    if (invoiceNumber) {
      setValue("gstCheckbox", true);
    } else {
      setValue("gstCheckbox", false);
    }
  }, [invoiceNumber]);

  useEffect(() => {
    // if(TotalRODiscount){

    if (gstCheckbox && TotalTaxableAmount) {
      setValue(
        "TotalBillAmount",
        (
          +TotalTaxableAmount * 0.03 +
          +TotalTaxableAmount -
          +TotalRODiscount
        )?.toFixed(3)
      );
      setValue("TotalGst", (+TotalTaxableAmount * 0.03)?.toFixed(3));
    } else {
      setValue(
        "TotalBillAmount",
        ((+TotalTaxableAmount || 0) - (+TotalRODiscount || 0))?.toFixed(3)
      );
      setValue("TotalGst", "");
    }
    // }
  }, [TotalTaxableAmount, gstCheckbox, TotalRODiscount, skus]);

  useEffect(() => {
    if (category == looseDiamondId) {
      const updatedFields = itemLooseDiamondfields?.map((field) => {
        if (DiamondFields.includes(field.key)) {
          return {
            ...field,
            IsVisible: true,
          };
        } else {
          return {
            ...field,
            IsVisible: false,
          };
        }
      });
      setFields(updatedFields);
    } else if (category == looseStoneId) {
      const updatedFields = itemLooseStonefields?.map((field) => {
        if (StoneFields.includes(field.key)) {
          return {
            ...field,
            IsVisible: true,
          };
        } else {
          return {
            ...field,
            IsVisible: false,
          };
        }
      });
      setFields(updatedFields);
    } else {
      setFields(itemfields);
    }
  }, [category]);

  useEffect(() => {
    let paidMetal = 0;
    let advanceAmount = 0;
    let balanceMetal = 0;
    let paidAmount = 0;
    console.log(paymentTypes);
    paymentTypes?.forEach((item) => {
      if (item?.status == "paid" && item?.mode == "Metal") {
        paidMetal += +item?.MetalFinePaid || 0;
      }
      if (item?.status == "advance") {
        advanceAmount += +item?.amount || 0;
      }
      if (
        item?.status == "paid" &&
        (item?.mode == "Cash" || item?.mode == "Metal to Cash")
      ) {
        paidAmount += +(item?.amount || item?.MetalCashTotalAmount || 0);
        if (item?.MetalCashTotalAmount) {
          setValue(
            "TotalTaxableAmount",
            (
              +(TotalTaxableAmount || 0) - +(item?.MetalCashTotalAmount || 0)
            )?.toFixed(3)
          );
        }
      }
    });

    if (+TotalFineMetal) {
      balanceMetal = +TotalFineMetal - +paidMetal;
    } else {
      balanceMetal = 0 - +paidMetal;
    }

    setValue("TotalPaidMetal", (+paidMetal)?.toFixed(3));
    setValue("TotalBalanceMetal", (+balanceMetal)?.toFixed(3));
    setValue("TotalAdvanceAmount", (+advanceAmount)?.toFixed(3));
    setValue("TotalPaidAmount", (+paidAmount)?.toFixed(3));
  }, [paymentTypes, TotalFineMetal]);

  useEffect(() => {
    setValue(
      "TotalBalanceAmount",
      (+TotalBillAmount - +TotalPaidAmount)?.toFixed(3)
    );
  }, [TotalBillAmount, TotalPaidAmount]);
  const reloadData = () => {
    setShowModal(false); // Close the modal
    // loadData();
  };

  const addSku = (data) => {
    console.log(data);
    setValue("skus", [
      ...skus,
      {
        id: editStatus ? data?.id : Date.now(),
        ...data,
      },
    ]);
    setIsSummaryOpen(true);
  };

  const updateSku = (data) => {
    setValue(
      "skus",
      skus.map((sku) => (sku.id === data.id ? data : sku)) // Replace only the matching SKU
    );
    setEditValues();
    setEdit(false);
    setIsSummaryOpen(true);
  };
  const addPaymentMode = (data) => {
    setValue("paymentTypes", [
      ...paymentTypes,
      {
        // id: editStatus ? data?.id : Date.now(),
        ...data,
      },
    ]);
  };

  const onSubmit = async (data) => {
    if (!skus.length) {
      toast.error("Atleast one item needed");
      return;
    }
    console.log(data);
    const formData = getPurchaseEntryFormData({
      data,
      selectedFiles: [],
      vendorlist,
      clientCode,
      invoiceDate,
      CompanyId,
      CounterId,
      BranchId,
      EmployeeId,
    });

    setPurchaseCreateLoading(true);
    if (editStatus) {
      formData.append("Id", data?.Id);
      try {
        const response = await fetch(a166, {
          method: "POST",
          body: formData,
        });
        const jsondata = await response.json();
        console.log(jsondata);
        if (jsondata?.Id) {
          await sendProductData(jsondata?.Id, data);
        }
      } catch (error) {
        console.log(error);
        setPurchaseCreateLoading(false);
        toast.error(error?.message || "Failed to update purchase information.");
      }
    } else {
      try {
        const response = await fetch(a154, {
          method: "POST",
          body: formData,
        });
        const jsondata = await response.json();
        if (jsondata?.Id) {
          await sendProductData(jsondata?.Id, data);
        }
      } catch (error) {
        console.log(error);
        setPurchaseCreateLoading(false);
      }
    }
  };

  async function sendProductData(rcvdId, data) {
    try {
      const additionalInfo = {
        clientCode,
        EmployeeId,
        CompanyId,
        BranchId,
        CounterId,
        labelFormat,
      };
      const payload = editStatus
        ? purchaseEntryEditJSon({ rcvdId, data, additionalInfo, vendorlist })
        : purchaseEntryJson({ rcvdId, data, additionalInfo, vendorlist });
      const response = await fetch(a155, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const paymentResponse = await fetch(editStatus ? a167 : a156, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload[0]?.Payments),
      });

      toast.success(
        `Purchase entry has been ${
          editStatus ? "updated" : "created"
        } successfully.`
      );

      if (editStatus) {
        navigate("/purchase_entries_list");
      } else {
        RDPurchaseRefetch();
        setTimeout(() => {
          navigate("/purchase_entry_new");
        }, 2000);
      }
    } catch (error) {
      console.log("error", error);
      toast.success(error?.message);
    } finally {
      setPurchaseCreateLoading(false);
    }
  }

  const handleReset = () => {
    if (editStatus && id) {
      navigate(`/edit_purchase_entry_new/${id}`);
    } else {
      RDPurchaseRefetch();
      navigate("/purchase_entry_new");
    }
  };



  return (
    <>
      <div>
        <AdminHeading />

        {/* {loading ? (
          // Show spinner while loading
          <div className="spinner-container">
            <ClipLoader size={50} color={"#123abc"} loading={loading} />
            {/* <p>Loading data...</p> */}
          {/* </div> */}
        {/* ) : ( */} 
          <>
            <div>
              <ErrorModal
                isOpen={showModal}
                onRequestClose={() => {
                  setShowModal(false); // Close the modal
                  navigate("/adminhome"); // Redirect to /adminhome
                }}
                onReload={reloadData} // Pass reload function
                message={errorMessage}
              />

              <div className="adminMainBodyBox">
                {showError ? (
                  <AlertMessage message={messageToShow} type={messageType} />
                ) : null}
              </div>
            </div>
          </>
        {/* )} */}

        <AdminBreadCrump
          title={`${
            editStatus ? "Update Purchase Entry" : "Add Purchase Entry"
          }`}
          companyName={"Loyalstring"}
          module={"Transactions"}
          page={`${
            editStatus ? "Update Purchase Entry" : "Add Purchase Entry"
          }`}
        />
      </div>



      <form className={styles.mainbox}>
        {/*basic detail section */}
        <div className={styles.linesection} style={{ padding: "0px 20px" }}>
          <div className={styles.infoline}>
            <div className={styles.box}>
              <label>Invoice No.</label>
              <input
                {...register("invoiceNumber", {
                  required: false,
                })}
                style={{
                  width: "100%", // Desktop: 50%, Mobile: 100%
                }}
              />
            </div>
            <div
              className={styles.dateSection}
              // style={{ alignItems: "center" ,justifyContent:'end'}}
            >
              <div>
                Lot No.{" "}
                <strong style={{ color: "blue" }}>{LotNumber || "--"}</strong>
              </div>
              <div style={{ position: "relative", display: "inline-block" }}>
                <input
                  id="invoiceDate"
                  type="date"
                  {...register("invoiceDate")}
                  style={{
                    width: "100%",
                    padding: "5px 10px",
                    paddingRight: "30px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* top section */}
        <div className={styles.linesection}>
          <div className={styles.container}>
            {itemfields
              ?.filter((field) => field?.place === "top" && field.IsVisible)
              .sort((a, b) => a.priority - b.priority)
              .map((field, index) => (
                <div className={styles.box}>
                  <label>
                    {field.label}{" "}
                    {field?.mandatory && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </label>
                  {field.type === "inputselect" ? (
                    // SKU Input with datalist
                    <input
                      type="text"
                      name={field.key}
                      placeholder={`${field.label}`}
                      disabled={field.visibility === "ReadOnly"}
                      {...register(field.key, {
                        required:
                          field?.mandatory &&
                          field.visibility !== "ReadOnly" &&
                          `${field.label} is required`,
                      })}
                      list="skuList"
                      autoComplete="off"
                      style={{ border: "1px solid #ddd" }}
                      // onKeyDown={(e) => handleKeyDown(e, index, itemfields.length)} // Adding the event handler

                      // disable={true}
                    />
                  ) : field.type === "dropdown" ||
                    field.type === "searchDropdown" ? (
                    <Controller
                      name={field.key}
                      control={control}
                      rules={{
                        required:
                          field?.mandatory &&
                          field.visibility !== "ReadOnly" &&
                          `${field.label} is required`,
                      }}
                      render={({ field: controllerField }) => (
                        <Select
                          {...controllerField}
                          options={
                            field.key === "VendorName"
                              ? Array.isArray(vendorlist)
                                ? vendorlist.map((vendor) => ({
                                    value: vendor.Id,
                                    label: vendor.VendorName,
                                  }))
                                : []
                              : []
                          }
                          isDisabled={field.visibility === "ReadOnly"}
                          isSearchable={field.type === "searchDropdown"}
                          placeholder="-- select --"
                          styles={selectStyle}
                        />
                      )}
                    />
                  ) : field.type === "number" || field.type === "text" ? (
                    // Number input field
                    <input
                      name={field.key}
                      type={field.type}
                      placeholder={`${field.label}`}
                      {...register(field.key, {
                        required:
                          field.visibility !== "ReadOnly" &&
                          field?.mandatory &&
                          `${field.label} is required`,
                        pattern: field.type === "number" ? /^\d+$/ : undefined,
                      })}
                      style={{ border: "1px solid #ddd" }}
                      disabled={field.visibility === "ReadOnly"}
                      // onKeyDown={(e) => handleKeyDown(e, index, itemfields.length)} // Adding the event handler
                    />
                  ) : null}
                  {errors[field.key] && (
                    <span className={styles.fielderror}>
                      {errors[field.key].message}
                    </span>
                  )}
                </div>
              ))}
          </div>
        </div>
        {isSummaryOpen ? (
          <div className={styles.summarySection}>
            <>
              {skus[0]?.CategoryId?.value != looseStoneId &&
              skus[0]?.CategoryId?.value != looseDiamondId ? (
                <Summary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  TotalFineMetal={TotalFineMetal}
                  
                />
              ) : skus[0]?.CategoryId?.value == looseStoneId ? (
                <StoneSummary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : skus[0]?.CategoryId?.value == looseDiamondId ? (
                <DiamondSummary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : (
                ""
              )}
            </>
          </div>
        ) : (
          <>
            {/* middle section */}
            <SkuForm
              skus={skus}
              isInvoiceEntry={false}
              itemfields={fields}
              editValues={editValues}
              edit={edit}
              updateSku={updateSku}
              addSku={addSku}
              isSummaryOpen={isSummaryOpen}
              setIsSummaryOpen={setIsSummaryOpen}
              apifields={apifields}
              setItemfields={setItemfields}
              setCategory={setCategory}
              VendorName={VendorName}
            />
          </>
        )}

        {/* bottom section */}
        <div className={styles.linesection}>
          {/* calculations section */}
          <div className={styles.calculation}>
            {/* Left Section */}

            <div className={styles.calculationleft}>
              <PaymentModeForm
                addPaymentMode={addPaymentMode}
                invoiceNumber={invoiceNumber}
                AdvanceAmount={AdvanceAmount}
              />

              <div className={styles.tableContainer}>
                <PaymentsEntryTable
                  styles={styles}
                  paymentTypes={paymentTypes}
                  setValue={setValue}
                />
              </div>
            </div>

            {/* Right Section */}

            <AmountSection styles={styles} register={register} />
          </div>
          {/* {errors.status && (
            <p className={styles.error}>{errors.status.message}</p>
          )} */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "10px",
          }}
        >
          <button
            style={{
              fontSize: "12px", // Smaller font size for responsiveness
              backgroundColor: "#0077d4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flex: "1 1 auto", // Allows buttons to shrink proportionally
              minWidth: "100px", // Minimum button width
              maxWidth: "150px", // Prevents overly wide buttons
            }}
            type="button"
            onClick={handleSubmit(onSubmit)}
            disabled={purchaseCreateLoading}
          >
            {purchaseCreateLoading ? <Spinner /> : <Check size={20} />}{" "}
            {/* Adjusted icon size */}
            Save
          </button>

          <button
            type="button"
            onClick={handleReset}
            style={{
              background: "#fff",
              fontSize: "12px", // Smaller font size for responsiveness
              color: "#0077D4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              border: "1px solid #0077D4",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            disabled={purchaseCreateLoading}
          >
            <Refresh size={20} /> {/* Adjusted icon size */}
            Reset
          </button>

          <button
            onClick={() => {
              navigate(`/purchase_entries_list`);
            }}
            type="button"
            style={{
              fontSize: "12px", // Smaller font size for responsiveness
              backgroundColor: "#0077d4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            disabled={purchaseCreateLoading}
          >
            <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />{" "}
            {/* Adjusted icon size */}
            Purchase List
          </button>
        </div>
      </form>
    </>
  );
};

export default AdminPurchaseEntryNew;
